let typeList = [
  {
    label: '待处理',
    value: 1,
  },
  {
    label: '诉讼中（一审）',
    value: 2,
  },
  {
    label: '诉讼中（二审）',
    value: 3,
  },
  {
    label: '执行阶段',
    value: 4,
  },
  {
    label: '刑事案件',
    value: 5,
  },
  {
    label: '不良资产',
    value: 6,
  },
  {
    label: '结案',
    value: 7,
  },
  // {
  //   label: '作废',
  //   value: 8,
  // },
];
import {
  submitLegalAffairsDetails,
} from '@/api/loanpost/loanLawCl';
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      minWidth: 120,
      search: true,
      searchOrder: 997,
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      minWidth: 100,
      type: 'input',
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchOrder: 999,
    },
    {
      label: '所属代理商',
      prop: 'deptIds',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
    {
      label: '剩余金额',
      prop: 'remainingAmount',
      type: 'input',
    },
    {
      label: '车型',
      prop: 'carModelName',
      type: 'input',
    },
    {
      label: '进度',
      prop: 'currentModule',
      type: 'select',
      filterable: true,
      search: true,
      searchClearable: true,
      searchOrder: 998,
      hide: true,
      dicData: typeList
    },
    {
      label: '进度',
      prop: 'currentModuleName',
      type: 'input',
    },
    {
      label: '创建日期',
      prop: 'createTimes',
      type: 'date',
      search: true,
      searchRange: true,
      hide: true,
      showColumn: false,
      searchType: 'daterange',
      valueFormat: 'yyyy-MM-dd',
      searchOrder: 996,
    },
    {
      label: '状态',
      prop: 'statusName',
      type: 'input',
    },
    {
      label: '创建日期',
      prop: 'createTime',
      type: 'input',
    },
    {
      label: '滞留时间',
      prop: 'residenceTime',
      type: 'input',
    },
  ],
};



export const operationButtonList = [
  {
    buttonName: '诉讼详情',
    iconfont: 'iconfont icon-shensu font-size_14"',
    dialogShow: 'lawsuitDetailsVisible',
    buttonShow: [2,3,4,5,6,7,8,9,10,14,12,13],
    requestFun: submitLegalAffairsDetails,
    buttonType: 35,
  },
  {
    buttonName: '刑案详情',
    iconfont: 'iconfont icon-shensu font-size_14"',
    dialogShow: 'criminalDetailsVisible',
    requestFun: submitLegalAffairsDetails,
    buttonShow: [11,15,16],
    buttonType: 37,
  },
];
